import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import AppPage from '@opsbase/web-app/AppPage';
import DVLPage from '@opsbase/web-dvl-page';
import React, { useCallback } from 'react';
import AssetsSelectionToolbar from '../toolbars/AssetsSelectionToolbar';
export function SetupAssetsPage() {
    var _a;
    const self = useSelf();
    const { data: org } = useOrgFindById({ variables: { id: self.organisationId } });
    const fieldNames = (_a = org === null || org === void 0 ? void 0 : org.settings) === null || _a === void 0 ? void 0 : _a.assetCustomFieldNames;
    const fieldSelector = useCallback((available) => {
        return available
            .map(a => {
            if (a.key.startsWith('customField')) {
                if (fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames[a.key]) {
                    return {
                        ...a,
                        label: fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames[a.key],
                    };
                }
                return null;
            }
            return a;
        })
            .filter(z => !!z);
    }, [fieldNames]);
    return (React.createElement(AppPage, null,
        React.createElement(DVLPage, { viewId: DataType.ASSET, itemSelectionToolbar: React.createElement(AssetsSelectionToolbar, null), itemPage: Pages.ASSETS_EDIT, itemCreatePage: Pages.ASSETS_CREATE, itemDeletePage: Pages.ASSETS_DELETE, notFoundText: i18n.t('no-assets-found'), fieldSelector: fieldSelector })));
}
export default SetupAssetsPage;
